app.mediator.registerModule(MODULE_NAME__CORE_CONTENT, function (app) {
    return {

        $rootElem: null,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {

            // Init
            var scope = this;
            this.$rootElem = $('.core-content');
            if (!this.$rootElem.length) { return };

            scope.addDomEventListeners();
            scope.addMediatorEventListeners();

            setTimeout(function() {
                var $projectPageElem = $('#projectPageContainer');
                var $galleryElem = $('.mod-gallery');
                if ((!$projectPageElem.length) && (!$galleryElem.length)) {
                    app.mediator.notify(EVENT_NAME__CORE_CONTENT__USER_LINGERD_ON_NON_PROJECT_PAGE);
                }
            }, 3000);
        },

        deinit: function () {
            app.globalEventRegistry.removeListener('adjustFooter');
        },

        //==========================================================xdiv2====
        // Event handlers
        //===================================================================

        addDomEventListeners: function () {

            var scope = this;
            var $modal = app.ui.uiPlugins.modal.getMainModalElem();
            $modal.on('shown.bs.modal', function () {
                scope.disable();
            });
            $modal.on('hidden.bs.modal', function () {
                scope.enable();
            });
        },

        addMediatorEventListeners: function () {

            var scope = this;

            // Disable

            app.mediator.addListener(EVENT_NAME__GALLERY_FILTERS__OPENED, function () {
                scope.disable();    
            });

            app.mediator.addListener(EVENT_NAME__GEO_SELECT__OPENED, function () {
                scope.disable(true);
            });

            app.mediator.addListener(EVENT_NAME__VIDEO_LIGHTBOX__PLAYING, function () {
                scope.disable();
            });

            app.mediator.addListener(EVENT_NAME__MAIN_NAV__OPENING, function () {
                scope.disableAllButMainMenu(true);
            });

            // Re-enable

            app.mediator.addListener(EVENT_NAME__GEO_SELECT__CLOSED, function () {
                scope.enable();
            });

            app.mediator.addListener(EVENT_NAME__GALLERY_FILTERS__CLOSED, function () {
                scope.enable();
            });

            app.mediator.addListener(EVENT_NAME__VIDEO_LIGHTBOX__PAUSED, function () {
                scope.enable();
            });

            app.mediator.addListener(EVENT_NAME__MAIN_NAV__CLOSED, function () {
                scope.enableAllButMainMenu();
            });
        },

        //==========================================================xdiv2====
        // Module
        //===================================================================

        disable: function (alsoVisuallyDisable) {
            this.$rootElem.ariaHideSrOnly(alsoVisuallyDisable);
            this.$rootElem.find('iframe').css({ display: 'none' });
            if (alsoVisuallyDisable) {
                this.$rootElem.addClass('visually-disabled');
            }
        },

        enable: function () {
            this.$rootElem.removeClass('visually-disabled');
            this.$rootElem.ariaShowSrOnly();
            this.$rootElem.find('iframe').css({ display: 'block' });
        },

        disableAllButMainMenu: function (alsoVisuallyDisable) {
            this.$rootElem.find('main#main').ariaHideSrOnly(alsoVisuallyDisable);
            this.$rootElem.find('div#footer').ariaHideSrOnly(alsoVisuallyDisable);
            this.$rootElem.find('.aux-nav').ariaHideSrOnly(alsoVisuallyDisable);
            this.$rootElem.find('iframe').css({ display: 'none' });
        },

        enableAllButMainMenu: function () {
            this.$rootElem.find('main#main').ariaShowSrOnly();
            this.$rootElem.find('div#footer').ariaShowSrOnly();
            this.$rootElem.find('iframe').css({ display: 'block' });
        }

    };
});